import { Check } from "lucide-react";

const TONES = {
  success: { bg: "bg-emerald-600", icon: "text-emerald-600" },
  exit: { bg: "bg-slate-900", icon: "text-slate-900" },
  warning: { bg: "bg-amber-500", icon: "text-amber-600" },
  error: { bg: "bg-rose-700", icon: "text-rose-700" },
};

export const ScanResultOverlay = ({ data, duration, contained = false, compact = false }) => {
  if (!data) return null;
  const { tone = "success", icon: Icon = Check, title, name, lines = [], time, note, testId } = data;
  const t = TONES[tone];
  return (
    <div
      className={`${contained ? "absolute" : "fixed"} inset-0 z-[60] flex flex-col items-center justify-center px-6 text-center text-white ${t.bg}`}
      data-testid={testId || "scan-result-overlay"}
    >
      <div className="pop-in relative mb-8">
        <span className="ring-pulse absolute inset-0 rounded-full bg-white/40" />
        <div className={`relative flex items-center justify-center rounded-full bg-white ${compact ? "h-24 w-24" : "h-28 w-28 sm:h-40 sm:w-40"}`}>
          <Icon className={`${compact ? "h-12 w-12" : "h-14 w-14 sm:h-20 sm:w-20"} ${t.icon}`} strokeWidth={3} />
        </div>
      </div>
      <p className={`pop-in-d1 font-display font-extrabold uppercase tracking-tight ${compact ? "text-2xl" : "text-3xl sm:text-5xl lg:text-6xl"}`} data-testid="scan-result-title">{title}</p>
      {name && <p className={`pop-in-d2 mt-5 font-display font-semibold ${compact ? "text-xl" : "text-2xl sm:text-4xl"}`} data-testid="scan-result-name">{name}</p>}
      {lines.map((l) => <p key={l} className={`pop-in-d2 mt-1 text-white/85 ${compact ? "text-sm" : "text-base sm:text-xl"}`}>{l}</p>)}
      {time && <p className={`pop-in-d2 mt-6 font-mono font-bold ${compact ? "text-3xl" : "text-4xl sm:text-6xl"}`} data-testid="scan-result-time">{time}</p>}
      {note && <p className="pop-in-d2 mt-6 rounded-full bg-white/15 px-4 py-2 text-sm font-medium" data-testid="scan-result-note">{note}</p>}
      <div className="absolute bottom-0 left-0 right-0 h-1.5 bg-white/20">
        <div className="progress-shrink h-full bg-white" style={{ "--dur": `${duration}ms` }} />
      </div>
    </div>
  );
};
